export default function OpenGraphDataService(
  CreativeService,
  FlashService,
  $http,
  $q
) {
  return {
    buildCreativeFromUrl,
    deserializeContentStructure,
    fetch,
    fetchOpenGraphContentData,
    updateCreativeWithOgData
  };

  function updateCreativeWithOgData(creative) {
    // NOTE: Do not use this with hosted videos (or article cards *)
    // for hosted videos, the mediaUrl field is used for the video URL
    // for article card, the mediaUrl field is used for the card iframe url
    //     * currently, this is used with article card, but mediaUrl is overwritten
    //      via a callback in the model
    if (creative.mediaUrl && !creative.mediaUrl.match('//')) {
      creative.mediaUrl = 'https://' + creative.mediaUrl;
    }

    return buildCreativeFromUrl(creative);
  }

  function buildCreativeFromUrl(creative) {
    const mediaUrl = creative.mediaUrl;

    return $http
      .get(`/creative_previews/open_graph_data?url=${mediaUrl}`)
      .then(({ data }) => {
        const ogTagData = data;
        if (
          ogTagData.headline ||
          ogTagData.thumbnailUrl ||
          ogTagData.description
        ) {
          creative.headline = ogTagData.headline;
          creative.thumbnailUrl = ogTagData.thumbnailUrl;
          creative.description = ogTagData.description;
        } else {
          FlashService.push(
            'error',
            'Unable to extract creative data from URL'
          );
        }

        return $q.resolve(creative);
      });
  }

  function fetch() {
    return fetchOpenGraphContentData().then(({ data }) => {
      const ogData = data;

      if (!ogData) {
        return;
      }

      deserializeContentStructure();

      if (ogData.oembedInfo) {
        CreativeService.creative.contentStructure[0].contentBlocks = [
          {
            id: 1,
            type: 'social',
            url: CreativeService.creative.mediaUrl,
            ogData: ogData.oembedInfo
          }
        ];
      } else {
        const textContent = `<h3>${ogData.title}</h3><p>${ogData.description}</p>`;

        CreativeService.creative.contentStructure[0].contentBlocks = [
          { id: 0, type: 'text', content: textContent },
          { id: 1, type: 'image', content: '', url: ogData.image }
        ];
      }
    });
  }

  function fetchOpenGraphContentData(url) {
    if (!url) {
      url = CreativeService.creative.mediaUrl;
    }

    return $http.get(`/open_graph_data?url=${url}`);
  }

  function deserializeContentStructure() {
    if (!CreativeService.creative.contentStructure) {
      CreativeService.creative.contentStructure = [{}];
    }

    let contentStructure = CreativeService.creative.contentStructure;

    if (typeof contentStructure === 'object') {
      return;
    }

    contentStructure = JSON.parse(contentStructure);

    contentStructure.forEach((page, pageIndex) => {
      page.id = pageIndex;
      page.contentBlocks.forEach((block, blockIndex) => {
        block.id = blockIndex;
      });
    });

    CreativeService.creative.contentStructure = contentStructure;
  }
}

OpenGraphDataService.$inject = [
  'CreativeService',
  'FlashService',
  '$http',
  '$q'
];
